module.exports = __webpack_public_path__ + "media/images/demo_reset-ab20dd3b0ecc36b18f63bc42d09043cfc6d9e990e11951d00204b48318cdb9b4.svg";